(() => {
  const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const coarse = window.matchMedia("(hover: none), (pointer: coarse)").matches;
  const phoneMq = window.matchMedia("(max-width: 900px)");
  const phone = phoneMq.matches;
  const in505 = document.body.classList.contains("is-505");
  const canGL = () => {
    try {
      const c = document.createElement("canvas");
      return !!(c.getContext("webgl") || c.getContext("experimental-webgl"));
    } catch (_) {
      return false;
    }
  };

  /* —— CSS orbs (fallback + leak) —— */
  const orbs = [...document.querySelectorAll("[data-orb]")];
  if (!in505 && orbs.length) {
    const blobs = orbs.map((el, i) => ({
      el,
      x: (0.08 + i * 0.18) * innerWidth,
      y: (0.12 + (i % 3) * 0.22) * innerHeight,
      vx: i % 2 ? 0.35 : -0.28,
      vy: i % 3 ? 0.22 : -0.18
    }));
    let mx = innerWidth * 0.5, my = innerHeight * 0.35;
    if (!phone) {
      addEventListener("pointermove", (e) => { mx = e.clientX; my = e.clientY; }, { passive: true });
    }
    const tick = () => {
      blobs.forEach((b, i) => {
        if (!reduced) {
          b.vx += (mx - b.x) * 0.00035;
          b.vy += (my - b.y) * 0.00028;
          b.vx += Math.sin(Date.now() / 1400 + i) * 0.04;
          b.vy += Math.cos(Date.now() / 1700 + i * 0.7) * 0.03;
          b.vx *= 0.985;
          b.vy *= 0.985;
          b.x += b.vx;
          b.y += b.vy;
          const pad = 80;
          if (b.x < -pad) b.vx = Math.abs(b.vx);
          if (b.x > innerWidth + pad) b.vx = -Math.abs(b.vx);
          if (b.y < -pad) b.vy = Math.abs(b.vy);
          if (b.y > innerHeight + pad) b.vy = -Math.abs(b.vy);
        }
        b.el.style.transform = `translate(${b.x}px, ${b.y}px)`;
      });
      if (!reduced) requestAnimationFrame(tick);
    };
    tick();
  }

  /* —— files drag lives in os.js —— */

  const title = document.querySelector(".glitch");
  if (title && !reduced) {
    setInterval(() => {
      if (Math.random() > 0.72) {
        title.classList.add("is-glitching");
        setTimeout(() => title.classList.remove("is-glitching"), 360);
      }
    }, 2800);
  }

  /* —— house radio + viz —— */
  const tracks = (window.FH && window.FH.tracks) || [];
  const radio = document.querySelector("[data-radio]");
  let analyser = null;
  let freq = null;
  let audioGraph = null;
  let radioHooked = false;
  let audioBass = 0;
  let audioMid = 0;
  let audioHi = 0;
  let audioBeat = false;
  let audioPrevBass = 0;
  let audioBeatAt = 0;
  const audioLive = () => !!(analyser && freq && radio && !radio.paused);
  const sampleAudio = (now) => {
    if (!audioLive()) {
      audioBass *= 0.86;
      audioMid *= 0.86;
      audioHi *= 0.86;
      audioBeat = false;
      return;
    }
    analyser.getByteFrequencyData(freq);
    const n = freq.length;
    const band = (a, b) => {
      let s = 0;
      let c = 0;
      const hi = Math.min(n, b);
      for (let i = a; i < hi; i++) {
        s += freq[i];
        c++;
      }
      return c ? s / (c * 255) : 0;
    };
    const bass = band(0, Math.max(2, Math.floor(n * 0.14)));
    const mid = band(Math.floor(n * 0.14), Math.floor(n * 0.48));
    const hi = band(Math.floor(n * 0.48), n);
    audioBass += (bass - audioBass) * 0.38;
    audioMid += (mid - audioMid) * 0.28;
    audioHi += (hi - audioHi) * 0.22;
    if (bass > 0.4 && bass - audioPrevBass > 0.07 && now - audioBeatAt > 160) {
      audioBeat = true;
      audioBeatAt = now;
    }
    audioPrevBass = bass;
  };
  const ensureAudio = async () => {
    if (audioGraph === false) return null;
    if (!audioGraph) {
      if (window.FH && window.FH.audioCtx) {
        audioGraph = window.FH.audioCtx;
      } else {
        try {
          audioGraph = new AudioContext();
          window.FH = window.FH || {};
          window.FH.audioCtx = audioGraph;
        } catch (_) {
          audioGraph = false;
          return null;
        }
      }
    }
    if (audioGraph.state === "suspended") {
      try { await audioGraph.resume(); } catch (_) {}
    }
    return audioGraph === false ? null : audioGraph;
  };
  const paintBars = (canvas, t) => {
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;
    const bars = Math.max(8, Math.floor(canvas.width / 8));
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    const w = canvas.width / bars;
    const live = analyser && freq && radio && !radio.paused;
    if (live) analyser.getByteFrequencyData(freq);
    for (let i = 0; i < bars; i++) {
      let h;
      if (live) {
        const v = freq[Math.min(freq.length - 1, Math.floor(i * freq.length / bars))] / 255;
        h = 3 + v * (canvas.height - 6);
      } else {
        h = 3 + Math.abs(Math.sin(t / 180 + i * 0.65)) * (canvas.height - 6) * 0.32;
      }
      ctx.fillStyle = i % 3 ? "#f4f1ec" : "#c4122e";
      ctx.fillRect(i * w + 1, canvas.height - h, w - 2, h);
    }
  };
  const viz = document.getElementById("DockViz");
  const winampViz = document.getElementById("WinampViz");
  const scope = document.getElementById("HudScope");
  if ((viz || winampViz) && !in505) {
    const draw = (t) => {
      paintBars(viz, t);
      paintBars(winampViz, t);
      if (!reduced) requestAnimationFrame(draw);
    };
    draw(0);
  }
  if (scope && !in505 && !phone) {
    const sctx = scope.getContext("2d");
    const paintScope = (t) => {
      const w = scope.width, h = scope.height;
      sctx.fillStyle = "rgba(0,0,0,0.55)";
      sctx.fillRect(0, 0, w, h);
      sctx.strokeStyle = "rgba(196,18,46,0.22)";
      sctx.lineWidth = 1;
      for (let x = 0; x < w; x += 18) {
        sctx.beginPath(); sctx.moveTo(x, 0); sctx.lineTo(x, h); sctx.stroke();
      }
      for (let y = 0; y < h; y += 16) {
        sctx.beginPath(); sctx.moveTo(0, y); sctx.lineTo(w, y); sctx.stroke();
      }
      sctx.beginPath();
      for (let x = 0; x < w; x++) {
        const y = h * 0.5
          + Math.sin(x * 0.085 + t / 160) * 16
          + Math.sin(x * 0.21 + t / 90) * 7
          + Math.sin(x * 0.41 + t / 40) * 3;
        if (x) sctx.lineTo(x, y); else sctx.moveTo(x, y);
      }
      sctx.strokeStyle = "#c4122e";
      sctx.lineWidth = 1.4;
      sctx.stroke();
      if (!reduced) requestAnimationFrame(paintScope);
    };
    paintScope(0);
  }

  if (radio && tracks.length && !in505) {
    let idx = 0;
    const titles = document.querySelectorAll("[data-radio-title]");
    const playBtns = document.querySelectorAll("[data-radio-play]");
    const sync = () => {
      const t = tracks[idx];
      titles.forEach((el) => { el.textContent = t.title; });
      document.querySelectorAll("[data-radio-pick]").forEach((btn) => {
        btn.classList.toggle("is-now", Number(btn.dataset.radioPick) === idx);
      });
      const on = !radio.paused;
      playBtns.forEach((btn) => {
        const lab = btn.querySelector("[data-radio-play-label]");
        if (lab) {
          if (btn.classList.contains("winamp__play") || btn.classList.contains("os-win__play")) {
            lab.textContent = on ? "❚❚ PAUSE" : "▶ PLAY";
          } else {
            lab.textContent = on ? "❚❚" : "▶";
          }
        }
        btn.classList.toggle("is-on", on);
        btn.setAttribute("aria-pressed", on ? "true" : "false");
      });
    };
    const load = (n, autoplay) => {
      idx = (n + tracks.length) % tracks.length;
      radio.src = tracks[idx].src;
      sync();
      if (autoplay) radio.play().catch(() => {});
    };
    const hookGraph = async () => {
      const ctx = await ensureAudio();
      if (!ctx || radioHooked) return;
      try {
        const src = ctx.createMediaElementSource(radio);
        analyser = ctx.createAnalyser();
        analyser.fftSize = 256;
        analyser.smoothingTimeConstant = 0.62;
        freq = new Uint8Array(analyser.frequencyBinCount);
        src.connect(analyser);
        analyser.connect(ctx.destination);
        radioHooked = true;
      } catch (_) {}
    };
    const toggle = async () => {
      await hookGraph();
      if (radio.paused) {
        if (!radio.src) load(idx, false);
        await radio.play();
      } else {
        radio.pause();
      }
      sync();
    };
    load(0, false);
    playBtns.forEach((btn) => btn.addEventListener("click", (e) => {
      e.preventDefault();
      toggle();
    }));
    const prev = document.querySelector("[data-radio-prev]");
    const next = document.querySelector("[data-radio-next]");
    if (prev) prev.addEventListener("click", () => load(idx - 1, !radio.paused));
    if (next) next.addEventListener("click", () => load(idx + 1, !radio.paused));
    document.querySelectorAll("[data-radio-pick]").forEach((btn) => {
      btn.addEventListener("click", async () => {
        await hookGraph();
        load(Number(btn.dataset.radioPick), true);
      });
    });
    radio.addEventListener("ended", () => load(idx + 1, true));
    radio.addEventListener("play", sync);
    radio.addEventListener("pause", sync);
  }

  /* —— 2D caustics only if no GL —— */
  const startCaustics = () => {
    if (!caustic || reduced || in505) return;
    const ctx = caustic.getContext("2d");
    const fit = () => { caustic.width = innerWidth; caustic.height = innerHeight; };
    fit();
    addEventListener("resize", fit);
    let t = 0, mx = 0.5, my = 0.35;
    if (!coarse) {
      addEventListener("pointermove", (e) => {
        mx = e.clientX / innerWidth;
        my = e.clientY / innerHeight;
      }, { passive: true });
    }
    const draw = () => {
      t += 0.012;
      ctx.clearRect(0, 0, caustic.width, caustic.height);
      for (let i = 0; i < 10; i++) {
        const x = (Math.sin(t * 0.9 + i * 0.8) * 0.5 + 0.5) * caustic.width + (mx - 0.5) * 120;
        const y = (Math.cos(t * 0.55 + i * 0.5) * 0.5 + 0.38) * caustic.height * 0.75 + (my - 0.5) * 80;
        const g = ctx.createRadialGradient(x, y, 0, x, y, 140 + (i % 4) * 28);
        g.addColorStop(0, i % 2 ? "rgba(196,18,46,.16)" : "rgba(244,241,236,.08)");
        g.addColorStop(1, "transparent");
        ctx.fillStyle = g;
        ctx.beginPath();
        ctx.arc(x, y, 190, 0, Math.PI * 2);
        ctx.fill();
      }
      requestAnimationFrame(draw);
    };
    draw();
  };

  const caustic = document.getElementById("FxCaustic");
  const useGL = !in505 && !reduced && canGL();

  /* —— wireframe only. no sunset, palms, orbs —— */
  if (useGL) {
    import("three").then((THREE) => {
        const bootWings3D = () => {
          // Park full WINGS.png 3D stack while the sliced [data-seal] logo is live.
          // A depth pass needs rim-only extrusion from the slice layers, not this stack.
          if (document.querySelector("[data-seal]")) return;
          const img = document.getElementById("WingsImg");
          const mark = img && img.closest(".os-mark");
          if (!img || !mark || reduced) return;
          const host = document.createElement("canvas");
          host.className = "os-mark__gl";
          host.setAttribute("aria-hidden", "true");
          img.insertAdjacentElement("afterend", host);
        const scene = new THREE.Scene();
        const camZ = 8;
        const camera = new THREE.PerspectiveCamera(32, 1, 0.1, 40);
        camera.position.set(0, 0, camZ);
        camera.lookAt(0, 0, 0);
        const renderer = new THREE.WebGLRenderer({ canvas: host, alpha: true, antialias: true });
        renderer.setClearColor(0x000000, 0);
        const group = new THREE.Group();
        scene.add(group);
        const HOUSE = { tilt: 0.07, depth: 1.4, glow: 1.13, idle: 0, layers: 12 };
        const cfg = { ...HOUSE };
        let texMap = null;
        let geo = null;
        let lookX = 0;
        let lookY = 0;
        let lookTX = 0;
        let lookTY = 0;
        let uniScale = 1;
        const staleWings = (w) => w && (
          (Number(w.glow) === 0.7 && Number(w.depth) === 0.34) ||
          (Number(w.tilt) === 0.15 && Number(w.depth) === 0.75 && Number(w.glow) === 0.99)
        );
        const readLab = () => {
          try {
            const parsed = JSON.parse(localStorage.getItem("fh-lab-v6") || "null");
            const w = parsed && parsed.wings;
            return staleWings(w) ? null : w;
          } catch (_) {
            return null;
          }
        };
        const mergeWings = (w) => {
          if (!w || staleWings(w)) return false;
          let dirty = false;
          ["tilt", "depth", "glow", "idle", "layers"].forEach((k) => {
            const n = Number(w[k]);
            if (!Number.isFinite(n) || cfg[k] === n) return;
            cfg[k] = n;
            dirty = true;
          });
          return dirty;
        };
        const fit = () => {
          const w = Math.max(1, host.clientWidth);
          const h = Math.max(1, host.clientHeight);
          renderer.setPixelRatio(Math.min(devicePixelRatio || 1, phone ? 1.2 : 1.6));
          renderer.setSize(w, h, false);
          camera.aspect = w / h;
          camera.updateProjectionMatrix();
          const visibleH = 2 * Math.tan((camera.fov * Math.PI) / 360) * camZ;
          const visibleW = visibleH * camera.aspect;
          const imgW = Math.max(1, img.clientWidth);
          const imgH = Math.max(1, img.clientHeight);
          const texAspect = Math.max(1, img.naturalWidth) / Math.max(1, img.naturalHeight);
          const boxW = visibleW * (imgW / w);
          const boxH = visibleH * (imgH / h);
          const uni = Math.min(boxW / 1, boxH / (1 / texAspect));
          uniScale = uni;
          group.scale.set(uni, uni, 1);
        };
        const clearGroup = () => {
          while (group.children.length) {
            const mesh = group.children[0];
            group.remove(mesh);
            if (mesh.material) mesh.material.dispose();
          }
          if (geo) {
            geo.dispose();
            geo = null;
          }
        };
        const rebuild = () => {
          if (!texMap) return;
          clearGroup();
          const n = cfg.layers > 0 ? Math.round(cfg.layers) : (phone ? 8 : 11);
          const layers = Math.max(4, Math.min(24, n));
          const texAspect = Math.max(1, img.naturalWidth) / Math.max(1, img.naturalHeight);
          geo = new THREE.PlaneGeometry(1, 1 / texAspect);
          for (let i = 0; i < layers; i++) {
            const t = i / Math.max(1, layers - 1);
            const front = i === layers - 1;
            const back = 1 - t;
            const mat = new THREE.MeshBasicMaterial({
              map: texMap,
              transparent: true,
              alphaTest: front ? 0.16 : 0.04,
              depthWrite: front,
              side: THREE.DoubleSide,
              color: front ? 0xffffff : (i % 2 ? 0x5a0610 : 0xcc1e1e),
              opacity: front ? 1 : (0.42 + t * 0.18) * cfg.glow
            });
            const mesh = new THREE.Mesh(geo, mat);
            mesh.position.set(0, 0, -back * cfg.depth);
            group.add(mesh);
          }
          fit();
          mark.classList.add("is-3d");
        };
        const onTex = (tex) => {
          tex.colorSpace = THREE.SRGBColorSpace;
          tex.minFilter = THREE.LinearFilter;
          tex.magFilter = THREE.LinearFilter;
          tex.anisotropy = 4;
          tex.needsUpdate = true;
          texMap = tex;
          mergeWings(readLab());
          rebuild();
        };
        const loader = new THREE.TextureLoader();
        loader.setCrossOrigin("anonymous");
        const start = () => {
          fit();
          loader.load(img.currentSrc || img.src, onTex, undefined, () => {
            const fallback = new THREE.Texture(img);
            fallback.needsUpdate = true;
            onTex(fallback);
          });
        };
        if (img.complete && img.naturalWidth) start();
        else img.addEventListener("load", start, { once: true });
        addEventListener("pointermove", (e) => {
          if (innerWidth <= 900) return;
          const span = cfg.tilt;
          const r = img.getBoundingClientRect();
          const dx = (e.clientX - (r.left + r.width / 2)) / Math.max(innerWidth * 0.5, 1);
          const dy = (e.clientY - (r.top + r.height / 2)) / Math.max(innerHeight * 0.5, 1);
          lookTX = Math.max(-span, Math.min(span, dx * span));
          lookTY = Math.max(-span * 0.72, Math.min(span * 0.72, dy * span * 0.72));
        }, { passive: true });
        addEventListener("resize", fit);
        if (typeof ResizeObserver !== "undefined") {
          new ResizeObserver(fit).observe(mark);
        }
        addEventListener("fh:lab", (e) => {
          if (!mergeWings(e.detail && e.detail.wings)) return;
          rebuild();
        });
        let wingBurst = { next: 0, rx: 0, ry: 0, rz: 0, sx: 1, sy: 1, ox: 0, oy: 0, flash: 0, hide: 0, seed: 1 };
        const snapWing = (now, storm) => {
          const kind = Math.random();
          wingBurst.flash = 0;
          wingBurst.hide = 0;
          wingBurst.seed = Math.random() * 99;
          if (kind < 0.1) {
            wingBurst.hide = 1;
            wingBurst.sx = 1;
            wingBurst.sy = 1;
            wingBurst.rx = 0;
            wingBurst.ry = 0;
            wingBurst.rz = 0;
            wingBurst.ox = 0;
            wingBurst.oy = 0;
            wingBurst.next = now + 14 + Math.random() * 80;
          } else if (kind < 0.34) {
            wingBurst.sx = 0.28 + Math.random() * 1.6;
            wingBurst.sy = 0.22 + Math.random() * 1.75;
            wingBurst.rx = (Math.random() - 0.5) * (storm ? 0.55 : 0.4);
            wingBurst.ry = (Math.random() - 0.5) * (storm ? 0.62 : 0.44);
            wingBurst.rz = (Math.random() - 0.5) * (storm ? 0.42 : 0.3);
            wingBurst.ox = (Math.random() - 0.5) * 0.58;
            wingBurst.oy = (Math.random() - 0.5) * 0.42;
            wingBurst.flash = Math.random() > 0.32 ? 1 : 0;
            wingBurst.next = now + 16 + Math.random() * (storm ? 95 : 140);
          } else if (kind < 0.58) {
            wingBurst.sx = 0.7 + Math.random() * 0.75;
            wingBurst.sy = 0.5 + Math.random() * 1.1;
            wingBurst.rx = (Math.random() - 0.5) * 0.5;
            wingBurst.ry = (Math.random() - 0.5) * 0.56;
            wingBurst.rz = (Math.random() - 0.5) * 0.34;
            wingBurst.ox = (Math.random() > 0.5 ? 1 : -1) * Math.random() * 0.4;
            wingBurst.oy = (Math.random() - 0.5) * 0.24;
            wingBurst.next = now + 60 + Math.random() * (storm ? 280 : 520);
          } else if (kind < 0.8) {
            wingBurst.sx = 0.9 + Math.random() * 0.2;
            wingBurst.sy = 0.88 + Math.random() * 0.24;
            wingBurst.rx = (Math.random() - 0.5) * 0.1;
            wingBurst.ry = (Math.random() - 0.5) * 0.12;
            wingBurst.rz = (Math.random() - 0.5) * 0.08;
            wingBurst.ox = (Math.random() - 0.5) * 0.1;
            wingBurst.oy = (Math.random() - 0.5) * 0.08;
            wingBurst.next = now + 40 + Math.random() * (storm ? 220 : 760);
          } else {
            wingBurst.sx = 1 + (Math.random() - 0.5) * 0.95;
            wingBurst.sy = 0.35 + Math.random() * 1.25;
            wingBurst.rx = (Math.random() - 0.5) * 0.2;
            wingBurst.ry = (Math.random() - 0.5) * 0.48;
            wingBurst.rz = (Math.random() - 0.5) * 0.3;
            wingBurst.ox = (Math.random() > 0.5 ? 1 : -1) * (0.14 + Math.random() * 0.52);
            wingBurst.oy = (Math.random() - 0.5) * 0.28;
            wingBurst.flash = 1;
            wingBurst.next = now + 10 + Math.random() * 70;
          }
          if (Math.random() > 0.8) wingBurst.next = now + 6 + Math.random() * 32;
        };
        const tick = (now) => {
          const t = now * 0.001;
          sampleAudio(now);
          lookX += (lookTX - lookX) * 0.14;
          lookY += (lookTY - lookY) * 0.14;
          const broken = document.body.classList.contains("is-broken");
          const storm = document.body.classList.contains("is-storming");
          const idle = cfg.idle * (innerWidth <= 900 ? 2.2 : 1);
          if (broken) {
            if (now >= wingBurst.next) snapWing(now, storm);
            group.rotation.y = -lookX + wingBurst.ry;
            group.rotation.x = lookY + wingBurst.rx;
            group.rotation.z = wingBurst.rz;
            group.scale.set(
              uniScale * (wingBurst.hide ? 0.04 : wingBurst.sx),
              uniScale * (wingBurst.hide ? 0.04 : wingBurst.sy),
              1
            );
          } else {
            wingBurst.next = 0;
            wingBurst.sx = 1;
            wingBurst.sy = 1;
            wingBurst.ox = 0;
            wingBurst.oy = 0;
            wingBurst.hide = 0;
            wingBurst.flash = 0;
            group.rotation.y = -lookX + Math.sin(t * 0.55) * idle;
            group.rotation.x = lookY + Math.cos(t * 0.41) * idle * 0.7;
            group.rotation.z = 0;
            group.scale.set(uniScale, uniScale, 1);
          }
          const last = Math.max(1, group.children.length - 1);
          for (let i = 0; i < group.children.length; i++) {
            const back = 1 - i / last;
            const j = broken
              ? (wingBurst.flash ? (Math.random() - 0.5) * (storm ? 0.16 : 0.1) : ((i * 2.13 + wingBurst.seed) % 1 - 0.5) * 0.05)
              : 0;
            group.children[i].position.x = -lookX * 0.1 * back + (broken ? wingBurst.ox * back : 0) + j;
            group.children[i].position.y = lookY * 0.08 * back + (broken ? wingBurst.oy * back : 0) + j * 0.6;
            group.children[i].position.z = -back * cfg.depth * (broken ? 1.12 : 1);
            if (broken && group.children[i].material && i < last) {
              group.children[i].material.opacity = wingBurst.hide
                ? 0
                : (wingBurst.flash ? Math.random() * cfg.glow : (0.28 + Math.random() * 0.5) * cfg.glow);
            } else if (group.children[i].material && i < last) {
              group.children[i].material.opacity = (0.42 + (i / last) * 0.18) * cfg.glow;
            }
          }
          renderer.render(scene, camera);
          requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      };
      bootWings3D();

      const canvas = document.getElementById("FxGL");
      if (!canvas) return;
      canvas.style.pointerEvents = "auto";
      canvas.style.touchAction = "none";
      const scene = new THREE.Scene();
      const camera = new THREE.PerspectiveCamera(phone ? 36 : 42, innerWidth / innerHeight, 0.1, 80);
      const camZ = phone ? 9.4 : 6.4;
      camera.position.set(0, 0, camZ);
      const renderer = new THREE.WebGLRenderer({ canvas, alpha: true, antialias: false });
      renderer.setPixelRatio(Math.min(devicePixelRatio || 1, phone ? 1.1 : 1.4));
      const fovRad = (phone ? 36 : 42) * Math.PI / 180;
      const fieldPoint = () => {
        const wings = document.getElementById("WingsImg");
        if (wings) {
          const r = wings.getBoundingClientRect();
          if (r.width > 8 && r.height > 8) {
            return { px: r.left + r.width / 2, py: r.top + r.height / 2 };
          }
        }
        let left = 0;
        let right = innerWidth;
        let top = 0;
        let bottom = innerHeight;
        const topBar = document.querySelector(".desk-top");
        const botBar = document.querySelector(".desk-bot");
        if (topBar && topBar.offsetHeight) top = topBar.getBoundingClientRect().bottom;
        if (botBar && botBar.offsetHeight) bottom = botBar.getBoundingClientRect().top;
        return { px: (left + right) / 2, py: (top + bottom) / 2 };
      };
      const logoAim = () => {
        const { px, py } = fieldPoint();
        const dist = camZ + 1.1;
        const h = 2 * Math.tan(fovRad / 2) * dist;
        const w = h * camera.aspect;
        return {
          x: (px / innerWidth - 0.5) * w,
          y: -(py / innerHeight - 0.5) * h
        };
      };
      const fit = () => {
        renderer.setSize(innerWidth, innerHeight, false);
        camera.aspect = innerWidth / innerHeight;
        camera.updateProjectionMatrix();
      };
      fit();
      addEventListener("resize", fit);

      const white = 0xf4f1ec;
      const red = 0xcc1e1e;
      const floorSize = phone ? 18 : 36;
      const floorSegs = phone ? 18 : 40;
      const floorN = floorSegs + 1;
      const floorGroup = new THREE.Group();
      floorGroup.position.set(0, phone ? -3.6 : -2.2, phone ? -2.2 : -3);
      scene.add(floorGroup);

      const floorGeo = new THREE.PlaneGeometry(floorSize, floorSize, floorSegs, floorSegs);
      floorGeo.rotateX(-Math.PI / 2);
      const floorCount = floorGeo.attributes.position.count;
      const floorColor = new Float32Array(floorCount * 3);
      floorGeo.setAttribute("color", new THREE.BufferAttribute(floorColor, 3));
      const floor = new THREE.Mesh(
        floorGeo,
        new THREE.MeshBasicMaterial({
          wireframe: true,
          vertexColors: true,
          transparent: true,
          opacity: phone ? 0.2 : 0.34,
          depthWrite: false
        })
      );
      floorGroup.add(floor);

      const hitMesh = new THREE.Mesh(
        new THREE.PlaneGeometry(floorSize, floorSize).rotateX(-Math.PI / 2),
        new THREE.MeshBasicMaterial({ visible: false, side: THREE.DoubleSide })
      );
      floorGroup.add(hitMesh);

      const height = new Float32Array(floorCount);
      const vel = new Float32Array(floorCount);
      const restY = new Float32Array(floorCount);
      const restX = new Float32Array(floorCount);
      const restZ = new Float32Array(floorCount);
      const posArr = floorGeo.attributes.position.array;
      for (let i = 0; i < floorCount; i++) {
        restX[i] = posArr[i * 3];
        restY[i] = posArr[i * 3 + 1];
        restZ[i] = posArr[i * 3 + 2];
      }

      const splash = (lx, lz, amp, radius, up) => {
        const r = Math.max(0.4, radius);
        const sign = up ? 1 : -1;
        for (let i = 0; i < floorCount; i++) {
          const dx = restX[i] - lx;
          const dz = restZ[i] - lz;
          const d = Math.sqrt(dx * dx + dz * dz);
          if (d >= r) continue;
          const w = 0.5 * (1 + Math.cos(Math.PI * d / r));
          vel[i] += sign * amp * w;
          if (up) height[i] += amp * w * 0.42;
        }
      };

      const shocks = [];
      const spawnShock = (lx, lz, hard) => {
        if (shocks.length > 10) {
          const old = shocks.shift();
          floorGroup.remove(old.line);
          old.line.geometry.dispose();
          old.line.material.dispose();
        }
        const line = new THREE.LineSegments(
          new THREE.EdgesGeometry(new THREE.RingGeometry(0.7, 0.78, 48)),
          new THREE.LineBasicMaterial({
            color: hard ? red : white,
            transparent: true,
            opacity: hard ? 0.95 : 0.7,
            depthWrite: false
          })
        );
        line.rotation.x = -Math.PI / 2;
        line.position.set(lx, 0.05, lz);
        floorGroup.add(line);
        shocks.push({ line, age: 0, life: hard ? 1.7 : 1.15, grow: hard ? 14 : 9 });
      };

      const tunnel = new THREE.Group();
      scene.add(tunnel);
      const rings = [];
      const ringN = phone ? 6 : 12;
      for (let i = 0; i < ringN; i++) {
        const geo = new THREE.EdgesGeometry(new THREE.BoxGeometry(2.4 + i * 0.05, 1.4, 0.02));
        const ring = new THREE.LineSegments(
          geo,
          new THREE.LineBasicMaterial({ color: i % 2 ? white : red, transparent: true, opacity: 0.22 })
        );
        ring.position.z = -1.1 - i * 1.15;
        tunnel.add(ring);
        rings.push(ring);
      }

      const raycaster = new THREE.Raycaster();
      const ndc = new THREE.Vector2();
      const hitLocal = (e) => {
        const rect = canvas.getBoundingClientRect();
        const w = rect.width || innerWidth;
        const h = rect.height || innerHeight;
        if (!w || !h) return null;
        ndc.set(((e.clientX - rect.left) / w) * 2 - 1, -((e.clientY - rect.top) / h) * 2 + 1);
        camera.updateMatrixWorld();
        hitMesh.updateWorldMatrix(true, false);
        raycaster.setFromCamera(ndc, camera);
        const hits = raycaster.intersectObject(hitMesh, false);
        if (!hits.length) return null;
        return floorGroup.worldToLocal(hits[0].point.clone());
      };

      const uiBlock = ".os-file, .os-win, .os-tv, .os-photos-fs, .os-seal, .desk-rail, .desk-top, .desk-bot, .desk-task, .os-dock, .os-bar, .fh-consent, .boot, .lab, .lab-toggle, a, button, input, textarea, select, label, summary, [data-open-win], [data-open-file], [data-winamp], [data-consent]";
      const onFloor = (e) => {
        const t = e.target;
        if (!(t instanceof Element)) return true;
        if (document.body.classList.contains("is-photos-full")) return false;
        if (t.closest(uiBlock)) return false;
        return true;
      };

      let mx = 0, my = 0, tx = 0, ty = 0, running = true;
      let grabbing = false;
      let grabLocal = null;
      let lastWakeX = 999;
      let lastWakeZ = 999;
      let jolt = 0;
      let wireNoise = null;
      let wireVoices = 0;
      let lastWireAt = 0;
      const wireBuf = (ctx) => {
        if (wireNoise && wireNoise.sampleRate === ctx.sampleRate) return wireNoise;
        const n = Math.floor(ctx.sampleRate * 0.05);
        const buf = ctx.createBuffer(1, n, ctx.sampleRate);
        const data = buf.getChannelData(0);
        for (let i = 0; i < n; i++) data[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / n, 1.45);
        wireNoise = buf;
        return buf;
      };
      const ringWire = (ctx, lx, lz, hard, kind) => {
        if (kind === "drag" && wireVoices > 6) return;
        if (wireVoices > 11) return;
        const now = ctx.currentTime;
        const dist = Math.hypot(lx, lz);
        const pan = Math.max(-0.82, Math.min(0.82, lx / (floorSize * 0.42)));
        const drag = kind === "drag";
        const hz = (hard ? 112 : drag ? 248 : 178) + dist * (hard ? 8 : 15);
        const dur = hard ? 0.64 : drag ? 0.1 : 0.36;
        const music = audioLive() ? 0.58 : 1;
        const amp = (hard ? 0.22 : drag ? 0.042 : 0.14) * music * (phone ? 0.72 : 1);
        const master = ctx.createGain();
        const panner = ctx.createStereoPanner();
        panner.pan.setValueAtTime(pan, now);
        master.connect(panner);
        panner.connect(ctx.destination);
        const noise = ctx.createBufferSource();
        noise.buffer = wireBuf(ctx);
        const bp = ctx.createBiquadFilter();
        bp.type = "bandpass";
        bp.frequency.setValueAtTime(hz * 2.7, now);
        bp.Q.value = hard ? 2.8 : 7.2;
        const ng = ctx.createGain();
        ng.gain.setValueAtTime(Math.max(0.0008, amp * (hard ? 1 : 0.68)), now);
        ng.gain.exponentialRampToValueAtTime(0.0008, now + (hard ? 0.14 : 0.055));
        noise.connect(bp);
        bp.connect(ng);
        ng.connect(master);
        noise.start(now);
        noise.stop(now + 0.09);
        const partials = hard ? [1, 1.997, 3.02, 4.41, 6.68] : drag ? [1, 2.04] : [1, 2.01, 3.14, 4.73];
        partials.forEach((m, i) => {
          const o = ctx.createOscillator();
          o.type = i === 0 || i === 2 ? "sine" : "triangle";
          o.frequency.setValueAtTime(hz * m, now);
          o.frequency.exponentialRampToValueAtTime(Math.max(48, hz * m * 0.9), now + dur);
          const g = ctx.createGain();
          g.gain.setValueAtTime(Math.max(0.0008, amp * (0.4 / (i + 1))), now);
          g.gain.exponentialRampToValueAtTime(0.0008, now + dur * Math.max(0.35, 1 - i * 0.12));
          o.connect(g);
          g.connect(master);
          o.start(now);
          o.stop(now + dur + 0.05);
        });
        wireVoices++;
        setTimeout(() => { wireVoices = Math.max(0, wireVoices - 1); }, (dur + 0.1) * 1000);
      };
      const wireCtx = () => {
        if (window.FH && window.FH.audioCtx) audioGraph = window.FH.audioCtx;
        if (audioGraph === false) return null;
        if (!audioGraph) {
          try {
            audioGraph = new AudioContext();
            window.FH = window.FH || {};
            window.FH.audioCtx = audioGraph;
          } catch (_) {
            audioGraph = false;
            return null;
          }
        }
        if (audioGraph.state === "suspended") audioGraph.resume().catch(() => {});
        return audioGraph;
      };
      const tapWire = (lx, lz, hard, kind) => {
        const ctx = wireCtx();
        if (!ctx) return;
        ringWire(ctx, lx, lz, hard, kind);
      };

      const torn = new Uint8Array(floorCount);
      const tearX = new Float32Array(floorCount);
      const tearY = new Float32Array(floorCount);
      const tearZ = new Float32Array(floorCount);
      const tearV = new Float32Array(floorCount);
      let tearing = false;
      let tearUntil = 0;
      let regenOn = false;
      let shards = [];
      let grabStartY = 0;
      let grabLift = 0;
      let taut = null;
      const LIFT_BREAK = phone ? 2.15 : 2.85;
      const LIFT_MAX = phone ? 3.5 : 4.8;

      const tautSet = (lift) => {
        const ctx = wireCtx();
        if (!ctx) return;
        const now = ctx.currentTime;
        const u = Math.max(0, Math.min(1, lift / LIFT_BREAK));
        if (!taut) {
          const o = ctx.createOscillator();
          o.type = "sine";
          const o2 = ctx.createOscillator();
          o2.type = "triangle";
          const g = ctx.createGain();
          g.gain.value = 0.0008;
          o.connect(g);
          o2.connect(g);
          g.connect(ctx.destination);
          o.start();
          o2.start();
          taut = { o, o2, g };
        }
        taut.o.frequency.setTargetAtTime(128 + u * 380, now, 0.05);
        taut.o2.frequency.setTargetAtTime(256 + u * 520, now, 0.05);
        taut.g.gain.setTargetAtTime(0.0008 + u * u * 0.055, now, 0.06);
      };
      const tautStop = () => {
        if (!taut) return;
        const node = taut;
        taut = null;
        if (!audioGraph || audioGraph === false) return;
        const now = audioGraph.currentTime;
        node.g.gain.setTargetAtTime(0.0008, now, 0.05);
        setTimeout(() => {
          try { node.o.stop(); node.o2.stop(); node.o.disconnect(); node.o2.disconnect(); node.g.disconnect(); } catch (_) {}
        }, 220);
      };

      const snapTear = (lx, lz) => {
        const ctx = wireCtx();
        if (!ctx) return;
        const t0 = ctx.currentTime;
        const pan = Math.max(-0.8, Math.min(0.8, lx / (floorSize * 0.42)));
        const music = audioLive() ? 0.72 : 1;
        const master = ctx.createGain();
        const panner = ctx.createStereoPanner();
        panner.pan.setValueAtTime(pan, t0);
        master.gain.setValueAtTime(Math.max(0.0008, 0.34 * music), t0);
        master.gain.exponentialRampToValueAtTime(0.0008, t0 + 1.15);
        master.connect(panner);
        panner.connect(ctx.destination);
        const noise = ctx.createBufferSource();
        noise.buffer = wireBuf(ctx);
        noise.loop = true;
        const bp = ctx.createBiquadFilter();
        bp.type = "bandpass";
        bp.frequency.setValueAtTime(1600, t0);
        bp.frequency.exponentialRampToValueAtTime(160, t0 + 0.38);
        bp.Q.value = 1.6;
        const ng = ctx.createGain();
        ng.gain.setValueAtTime(1, t0);
        ng.gain.exponentialRampToValueAtTime(0.0008, t0 + 0.42);
        noise.connect(bp);
        bp.connect(ng);
        ng.connect(master);
        noise.start(t0);
        noise.stop(t0 + 0.44);
        [84, 168, 42].forEach((hz, i) => {
          const o = ctx.createOscillator();
          o.type = i === 1 ? "sawtooth" : "sine";
          o.frequency.setValueAtTime(hz, t0);
          o.frequency.exponentialRampToValueAtTime(Math.max(28, hz * 0.32), t0 + 0.72);
          const g = ctx.createGain();
          g.gain.setValueAtTime(0.3 / (i + 1), t0);
          g.gain.exponentialRampToValueAtTime(0.0008, t0 + 0.9);
          o.connect(g);
          g.connect(master);
          o.start(t0);
          o.stop(t0 + 0.95);
        });
      };

      const stitchGrid = () => {
        if (!audioGraph || audioGraph === false) return;
        const ctx = audioGraph;
        const t0 = ctx.currentTime;
        for (let k = 0; k < 6; k++) {
          const at = t0 + k * 0.075;
          const o = ctx.createOscillator();
          o.type = "sine";
          o.frequency.value = 540 + k * 95;
          const g = ctx.createGain();
          g.gain.setValueAtTime(0.0008, at);
          g.gain.exponentialRampToValueAtTime(0.065, at + 0.012);
          g.gain.exponentialRampToValueAtTime(0.0008, at + 0.09);
          o.connect(g);
          g.connect(ctx.destination);
          o.start(at);
          o.stop(at + 0.11);
        }
      };

      const spawnShards = (lx, lz) => {
        const n = phone ? 9 : 18;
        for (let k = 0; k < n; k++) {
          const geo = new THREE.BufferGeometry();
          const len = 0.16 + Math.random() * 0.58;
          const pos = new Float32Array([0, 0, 0, len, 0.05 * (Math.random() - 0.5), 0]);
          geo.setAttribute("position", new THREE.BufferAttribute(pos, 3));
          const line = new THREE.Line(
            geo,
            new THREE.LineBasicMaterial({
              color: k % 3 ? white : red,
              transparent: true,
              opacity: 0.95,
              depthWrite: false
            })
          );
          line.position.set(lx, 0.2, lz);
          line.rotation.set(Math.random() * 6, Math.random() * 6, Math.random() * 6);
          floorGroup.add(line);
          shards.push({
            line,
            vx: (Math.random() - 0.5) * 5.6,
            vy: 2.4 + Math.random() * 4.4,
            vz: (Math.random() - 0.5) * 5.6,
            rx: (Math.random() - 0.5) * 11,
            ry: (Math.random() - 0.5) * 11,
            age: 0,
            life: 0.65 + Math.random() * 0.9
          });
        }
      };

      const breakCloth = (now) => {
        if (tearing || !grabLocal) return;
        const rad = 2.35 + grabLift * 0.18;
        let n = 0;
        for (let i = 0; i < floorCount; i++) {
          const d = Math.hypot(restX[i] - grabLocal.x, restZ[i] - grabLocal.z);
          const w = Math.exp(-(d * d) / (rad * rad * 0.26));
          if (w < 0.15) continue;
          torn[i] = 1;
          tearX[i] = (Math.random() - 0.5) * (1.05 + w * 1.7);
          tearY[i] = grabLift * w * 0.5 + 0.45 + Math.random() * 2.5;
          tearZ[i] = (Math.random() - 0.5) * (1.05 + w * 1.7);
          tearV[i] = 1.1 + Math.random() * 3.4;
          height[i] = grabLift * w;
          vel[i] = 0.15;
          n++;
        }
        if (!n) return;
        tearing = true;
        regenOn = false;
        tearUntil = now + 3000 + Math.random() * 4000;
        spawnShards(grabLocal.x, grabLocal.z);
        spawnShock(grabLocal.x, grabLocal.z, true);
        spawnShock(grabLocal.x, grabLocal.z, false);
        snapTear(grabLocal.x, grabLocal.z);
        tautStop();
        jolt = 1;
        grabbing = false;
        grabLift = 0;
        grabLocal = null;
        document.body.classList.remove("is-floor-grab");
      };

      const grabAt = (e, drop) => {
        const p = hitLocal(e);
        if (!p) return;
        if (drop) grabLocal = p;
        else if (grabLocal) {
          grabLocal.x += (p.x - grabLocal.x) * 0.22;
          grabLocal.z += (p.z - grabLocal.z) * 0.22;
        } else grabLocal = p;
        if (drop) {
          const hard = e.shiftKey || (typeof e.pressure === "number" && e.pressure > 0.7);
          splash(p.x, p.z, hard ? 1.15 : 0.82, hard ? 2.8 : 2.15, true);
          spawnShock(p.x, p.z, hard);
          tapWire(p.x, p.z, hard, "hit");
          lastWakeX = p.x;
          lastWakeZ = p.z;
        }
      };

      addEventListener("pointerdown", (e) => {
        if (e.button) return;
        if (tearing) return;
        if (!onFloor(e)) return;
        if (!hitLocal(e)) return;
        grabbing = true;
        grabStartY = e.clientY;
        grabLift = phoneMq.matches ? 0.7 : 0.95;
        document.body.classList.add("is-floor-grab");
        grabAt(e, true);
        try { canvas.setPointerCapture(e.pointerId); } catch (_) {}
      });
      addEventListener("pointermove", (e) => {
        if (!phoneMq.matches) {
          tx = (e.clientX / innerWidth - 0.5) * 0.28;
          ty = (e.clientY / innerHeight - 0.5) * 0.16;
        }
        if (!grabbing) return;
        grabAt(e, false);
        const extra = Math.max(0, (grabStartY - e.clientY) / Math.max(1, innerHeight) * (phoneMq.matches ? 9.5 : 13));
        grabLift = Math.min(LIFT_MAX, (phoneMq.matches ? 0.7 : 0.95) + extra);
        tautSet(grabLift);
        if (grabLift >= LIFT_BREAK) {
          breakCloth(performance.now());
          return;
        }
        if (!grabLocal) return;
        const dx = grabLocal.x - lastWakeX;
        const dz = grabLocal.z - lastWakeZ;
        if (dx * dx + dz * dz > 0.16) {
          splash(grabLocal.x, grabLocal.z, 0.28, 1.45, true);
          const tnow = performance.now();
          if (tnow - lastWireAt > 80) {
            lastWireAt = tnow;
            tapWire(grabLocal.x, grabLocal.z, false, "drag");
          }
          lastWakeX = grabLocal.x;
          lastWakeZ = grabLocal.z;
        }
      });
      const endGrab = () => {
        if (!grabbing) return;
        tautStop();
        grabbing = false;
        grabLift = 0;
        grabLocal = null;
        document.body.classList.remove("is-floor-grab");
      };
      addEventListener("pointerup", endGrab);
      addEventListener("pointercancel", endGrab);
      document.addEventListener("visibilitychange", () => { running = !document.hidden; });

      let last = 0;
      const minDt = phone ? 33 : 0;
      let camKick = { x: 0, y: 0, z: 0 };
      let meshBurst = { until: 0, mode: 0, amp: 0, seed: 0, row: 0, col: 0, flicker: false };
      let floorTilt = 0;
      const tick = (now) => {
        if (!running) { requestAnimationFrame(tick); return; }
        if (now - last < minDt) { requestAnimationFrame(tick); return; }
        const dt = last ? Math.min(0.033, (now - last) / 1000) : 0.016;
        last = now;
        const t = now * 0.001;
        sampleAudio(now);
        const broken = document.body.classList.contains("is-broken");
        const storm = document.body.classList.contains("is-storming");
        const aim = logoAim();
        mx += (tx - mx) * 0.04;
        my += (ty - my) * 0.04;
        const onPhone = phoneMq.matches;
        tunnel.position.set(onPhone ? 0 : aim.x, onPhone ? -0.85 : aim.y, 0);
        floorGroup.position.set(onPhone ? 0 : aim.x, onPhone ? -3.6 : aim.y - 2.2, onPhone ? -2.2 : -3);
        if (broken && Math.random() > (storm ? 0.86 : 0.955)) {
          camKick.x = (Math.random() - 0.5) * (storm ? 0.16 : 0.08);
          camKick.y = (Math.random() - 0.5) * (storm ? 0.1 : 0.05);
          camKick.z = (Math.random() - 0.5) * (storm ? 0.22 : 0.1);
        }
        camKick.x *= 0.78;
        camKick.y *= 0.78;
        camKick.z *= 0.78;
        camera.position.x = onPhone ? camKick.x : mx * 0.22 + camKick.x;
        camera.position.y = onPhone ? camKick.y : my * -0.12 + camKick.y;
        camera.position.z = camZ + camKick.z;
        camera.lookAt(0, onPhone ? -1.25 : 0, -4);
        if (broken && now > meshBurst.until && Math.random() > (storm ? 0.72 : 0.86)) {
          meshBurst.mode = 1 + Math.floor(Math.random() * 8);
          meshBurst.amp = (storm ? 0.38 : 0.16) + Math.random() * (storm ? 1.55 : 0.95);
          meshBurst.seed = Math.floor(Math.random() * 99991);
          meshBurst.row = Math.floor(Math.random() * floorN);
          meshBurst.col = Math.floor(Math.random() * floorN);
          meshBurst.flicker = Math.random() > 0.4;
          meshBurst.until = now + 45 + Math.random() * (storm ? 340 : 520);
          jolt = Math.max(jolt, (storm ? 0.32 : 0.14) + Math.random() * (storm ? 0.5 : 0.28));
          if (Math.random() > 0.35) {
            splash((Math.random() - 0.5) * floorSize * 0.46, (Math.random() - 0.5) * floorSize * 0.46, storm ? 0.28 : 0.16, storm ? 1.8 : 1.2);
          }
        }
        const gOn = broken && now < meshBurst.until;
        const gMode = gOn ? meshBurst.mode : 0;
        floorGroup.rotation.y = t * (broken ? (storm ? 0.08 : 0.05) : 0.04);
        if (gOn && gMode === 7) floorTilt = (Math.random() - 0.5) * (storm ? 0.12 : 0.07);
        else floorTilt *= 0.84;
        floorGroup.rotation.z = floorTilt;
        floorGroup.rotation.x = gOn && gMode === 7 ? (Math.random() - 0.5) * 0.05 : floorTilt * 0.3;
        rings.forEach((r, i) => {
          r.visible = true;
          r.position.x = 0;
          r.position.y = 0;
          r.rotation.x = 0;
          r.rotation.y = 0;
          r.rotation.z = 0;
          r.scale.set(1, 1, 1);
          r.position.z = -1.1 - ((t * (broken ? 1.1 : 0.38) + i * 1.15) % (ringN * 1.15));
          if (broken) {
            r.material.opacity = 0.14 + Math.abs(Math.sin(t * 1.2 + i)) * 0.12;
            if (gOn && gMode === 5 && ((i + meshBurst.seed) % 3 === 0)) {
              r.visible = !(meshBurst.flicker && Math.random() > 0.35);
              r.material.opacity = Math.random() > 0.5 ? 0.05 : 0.85;
              r.scale.setScalar(0.55 + Math.random() * 1.1);
              r.position.x = (Math.random() - 0.5) * 0.55;
              r.rotation.z = (Math.random() - 0.5) * 0.45;
            }
            if (gOn && gMode === 8) {
              r.rotation.y = Math.sin(t * 11 + i) * 0.5;
              r.position.y = (Math.random() - 0.5) * 0.12;
            }
          } else {
            r.material.opacity = 0.22;
          }
        });
        if (broken && Math.random() > (storm ? 0.9 : 0.97)) {
          jolt = Math.max(jolt, storm ? 0.4 : 0.22);
          splash((Math.random() - 0.5) * floorSize * 0.42, (Math.random() - 0.5) * floorSize * 0.42, storm ? 0.22 : 0.14, storm ? 1.6 : 1.15);
        }
        jolt *= 0.9;
        const j = jolt * jolt;
        tunnel.scale.setScalar(1 + j * 0.06 + (gOn && gMode === 5 ? (Math.random() - 0.5) * 0.08 : 0));
        tunnel.rotation.z = (jolt - 0.5 * j) * 0.04 + (gOn && gMode === 8 ? (Math.random() - 0.5) * 0.08 : 0);

        if (tearing && now >= tearUntil && !regenOn) {
          regenOn = true;
          stitchGrid();
        }
        const regenU = tearing && regenOn ? Math.min(1, (now - tearUntil) / 920) : 0;
        if (tearing && regenOn && regenU >= 1) {
          tearing = false;
          regenOn = false;
          torn.fill(0);
          tearX.fill(0);
          tearY.fill(0);
          tearZ.fill(0);
          tearV.fill(0);
        }

        if (grabbing && grabLocal) {
          const rad = 3.4 + grabLift * 0.7;
          const peak = Math.max(0.85, grabLift * 1.45);
          for (let i = 0; i < floorCount; i++) {
            if (torn[i]) continue;
            const dx = restX[i] - grabLocal.x;
            const dz = restZ[i] - grabLocal.z;
            const d2 = dx * dx + dz * dz;
            if (d2 > rad * rad) continue;
            const w = Math.exp(-d2 / (rad * rad * 0.2));
            height[i] += (peak * w - height[i]) * 0.46;
            vel[i] *= 0.62;
          }
        }

        const stiff = phone ? 0.12 : 0.14;
        const restore = phone ? 0.028 : 0.032;
        const step = dt / 0.016;
        for (let y = 0; y < floorN; y++) {
          for (let x = 0; x < floorN; x++) {
            const i = y * floorN + x;
            if (torn[i] && !regenOn) continue;
            const l = x > 0 ? height[i - 1] : 0;
            const rgt = x < floorN - 1 ? height[i + 1] : 0;
            const up = y > 0 ? height[i - floorN] : 0;
            const dn = y < floorN - 1 ? height[i + floorN] : 0;
            const lap = l + rgt + up + dn - 4 * height[i];
            const edge = x === 0 || y === 0 || x === floorN - 1 || y === floorN - 1;
            vel[i] += (lap * stiff - height[i] * (edge ? restore * 2.4 : restore)) * step;
          }
        }
        let energy = 0;
        const flicker = gOn && meshBurst.flicker;
        for (let i = 0; i < floorCount; i++) {
          vel[i] *= torn[i] && !regenOn ? 0.92 : 0.96;
          vel[i] = Math.max(-1.4, Math.min(1.4, vel[i]));
          height[i] += vel[i];
          const yCap = grabbing ? LIFT_MAX + 0.4 : 2.4;
          if (height[i] > yCap) {
            height[i] = yCap;
            if (vel[i] > 0) vel[i] *= -0.22;
          } else if (height[i] < -2.4) {
            height[i] = -2.4;
            if (vel[i] < 0) vel[i] *= -0.22;
          }
          if (!torn[i] && Math.abs(height[i]) < 0.0012 && Math.abs(vel[i]) < 0.0012) {
            height[i] = 0;
            vel[i] = 0;
          }
          const mag = Math.min(1, Math.abs(height[i]) * 1.55);
          energy = Math.max(energy, mag);
          const row = Math.floor(i / floorN);
          const col = i % floorN;
          let gx = 0, gy = 0, gz = 0;
          if (gOn) {
            const amp = meshBurst.amp;
            if (gMode === 1 && row === meshBurst.row) {
              gx = amp * 1.6;
              gy = flicker ? (Math.random() - 0.5) * amp : amp * 0.45;
            } else if (gMode === 2 && col === meshBurst.col) {
              gz = amp;
              gy = flicker ? (Math.random() - 0.5) * amp * 0.8 : -amp * 0.5;
            } else if (gMode === 3 && ((i * 17 + meshBurst.seed) % 11) < 3) {
              gy += Math.sin(t * 42 + i) * amp;
              gx += Math.cos(t * 31 + i) * amp * 0.45;
            } else if (gMode === 4 && ((row + col) & 1) === 0) {
              gy += amp * (flicker ? Math.random() : 0.55);
            } else if (gMode === 6) {
              gy += Math.sin(col * 0.7 + t * 18) * amp * (Math.abs(row - meshBurst.row) < 2 ? 1.8 : 0.25);
              gx += Math.cos(row * 0.4) * amp * 0.2;
            } else if (gMode === 8 && Math.abs(row - meshBurst.row) < 3 && Math.abs(col - meshBurst.col) < 4) {
              gx += (Math.random() - 0.5) * amp * 1.2;
              gy += (Math.random() - 0.5) * amp * 1.4;
              gz += (Math.random() - 0.5) * amp;
            }
          }
          if (grabbing && grabLocal && !torn[i]) {
            const dx = restX[i] - grabLocal.x;
            const dz = restZ[i] - grabLocal.z;
            const d2 = dx * dx + dz * dz;
            const rad = 3.4 + grabLift * 0.7;
            if (d2 < rad * rad) {
              const w = Math.exp(-d2 / (rad * rad * 0.2));
              const gather = w * Math.min(1, grabLift / 1.6) * 0.38;
              gx += (grabLocal.x - restX[i]) * gather;
              gz += (grabLocal.z - restZ[i]) * gather;
            }
          }
          if (torn[i]) {
            if (!regenOn) {
              tearV[i] -= 6.8 * dt;
              tearY[i] += tearV[i] * dt * 18;
              tearX[i] *= 0.992;
              tearZ[i] *= 0.992;
              gx += tearX[i];
              gy += tearY[i];
              gz += tearZ[i];
            } else {
              const k = 1 - regenU;
              gx += tearX[i] * k;
              gy += tearY[i] * k;
              gz += tearZ[i] * k;
            }
          }
          posArr[i * 3] = restX[i] + gx;
          posArr[i * 3 + 1] = restY[i] + height[i] + gy;
          posArr[i * 3 + 2] = restZ[i] + gz;
          const axis = Math.min(Math.abs(restX[i]), Math.abs(restZ[i])) < floorSize / floorSegs * 0.55;
          let mix = axis ? Math.max(mag, 0.7) : mag;
          if (gOn && (gMode === 3 || gMode === 8) && ((i + meshBurst.seed) % 9) === 0) mix = 1;
          if (torn[i]) mix = regenOn ? Math.max(mix, 1 - regenU) : 1;
          if (grabbing && grabLift > LIFT_BREAK * 0.55 && !torn[i]) mix = Math.max(mix, Math.min(1, grabLift / LIFT_BREAK) * 0.55);
          floorColor[i * 3] = 0.956 * (1 - mix) + 0.769 * mix;
          floorColor[i * 3 + 1] = 0.945 * (1 - mix) + 0.071 * mix;
          floorColor[i * 3 + 2] = 0.925 * (1 - mix) + 0.180 * mix;
        }
        floorGeo.attributes.position.needsUpdate = true;
        floorGeo.attributes.color.needsUpdate = true;
        floor.material.opacity = 0.28 + energy * 0.22 + (broken ? 0.08 : 0) + (tearing && !regenOn ? 0.12 : 0);

        for (let s = shards.length - 1; s >= 0; s--) {
          const sh = shards[s];
          sh.age += dt;
          sh.vy -= 9.2 * dt;
          sh.line.position.x += sh.vx * dt;
          sh.line.position.y += sh.vy * dt;
          sh.line.position.z += sh.vz * dt;
          sh.line.rotation.x += sh.rx * dt;
          sh.line.rotation.y += sh.ry * dt;
          const u = Math.min(1, sh.age / sh.life);
          sh.line.material.opacity = (1 - u) * 0.95;
          if (u >= 1) {
            floorGroup.remove(sh.line);
            sh.line.geometry.dispose();
            sh.line.material.dispose();
            shards.splice(s, 1);
          }
        }

        for (let s = shocks.length - 1; s >= 0; s--) {
          const sh = shocks[s];
          sh.age += dt;
          const u = Math.min(1, sh.age / sh.life);
          sh.line.scale.setScalar(1 + u * sh.grow);
          sh.line.material.opacity = (1 - u) * (sh.line.material.color.getHex() === red ? 0.95 : 0.7);
          if (u >= 1) {
            floorGroup.remove(sh.line);
            sh.line.geometry.dispose();
            sh.line.material.dispose();
            shocks.splice(s, 1);
          }
        }

        renderer.render(scene, camera);
        requestAnimationFrame(tick);
      };
      document.body.classList.add("has-gl");
      requestAnimationFrame(tick);
    }).catch(() => { /* no GL */ });
  }

  /* —— tape wipe between rooms (same four doors, felt not puzzled) —— */
  const wipe = document.querySelector("[data-wipe]");
  if (wipe && !in505) {
    document.addEventListener("click", (e) => {
      const a = e.target.closest("a");
      if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      if (a.hasAttribute("data-open-win") || a.closest("[data-open-win]")) return;
      if (a.hasAttribute("data-open-file") || a.closest("[data-open-file]")) return;
      if (a.getAttribute("href")?.startsWith("#")) return;
      let url;
      try { url = new URL(a.href, location.href); } catch (_) { return; }
      if (url.origin !== location.origin) return;
      const samePath = url.pathname.replace(/\/+$/, "") === location.pathname.replace(/\/+$/, "");
      if (samePath && url.hash) return;
      if (samePath && url.search === location.search) return;
      if (/\/505|\/cart|\/checkout|\/account/.test(url.pathname)) return;
      if (reduced) return;
      e.preventDefault();
      document.body.classList.add("is-wiping");
      setTimeout(() => { location.href = url.href; }, 300);
    });
  }

  /* —— assembler liturgy in the OS bar —— */
  const asm = document.querySelector(".os-bar__asm");
  if (asm && !reduced) {
    const lines = ["LDA #$05", "STA $333", "JSR WINGS", "BIT WINGS", "NOP", "INC $FF"];
    let i = 0;
    setInterval(() => { i = (i + 1) % lines.length; asm.textContent = lines[i]; }, 2200);
  }

  /* —— desk windows: click to front (art, not a maze) —— */
  document.querySelectorAll(".desk-win").forEach((w) => {
    w.addEventListener("pointerdown", () => {
      document.querySelectorAll(".desk-win").forEach((x) => x.classList.remove("is-front"));
      w.classList.add("is-front");
    });
  });

  /* —— radar (about + hero HUD) —— */
  document.querySelectorAll("[data-radar], [data-hero-radar]").forEach((radar) => {
    if (reduced) return;
    if (radar.hasAttribute("data-hero-radar") && phone) return;
    const ctx = radar.getContext("2d");
    const cx = radar.width / 2, cy = radar.height / 2, R = Math.min(cx, cy) - 4;
    let ang = 0;
    const draw = () => {
      ctx.fillStyle = "rgba(0,0,0,0.35)";
      ctx.fillRect(0, 0, radar.width, radar.height);
      ctx.strokeStyle = "rgba(244,241,236,0.28)";
      ctx.lineWidth = 1;
      for (let r = R / 4; r <= R; r += R / 4) {
        ctx.beginPath(); ctx.arc(cx, cy, r, 0, Math.PI * 2); ctx.stroke();
      }
      ctx.beginPath(); ctx.moveTo(cx - R, cy); ctx.lineTo(cx + R, cy); ctx.stroke();
      ctx.beginPath(); ctx.moveTo(cx, cy - R); ctx.lineTo(cx, cy + R); ctx.stroke();
      ctx.fillStyle = "#c4122e";
      ctx.beginPath(); ctx.arc(cx + Math.cos(ang * 1.7) * R * 0.55, cy + Math.sin(ang * 1.3) * R * 0.4, 2.2, 0, Math.PI * 2); ctx.fill();
      const g = ctx.createLinearGradient(cx, cy, cx + Math.cos(ang) * R, cy + Math.sin(ang) * R);
      g.addColorStop(0, "rgba(244,241,236,0)");
      g.addColorStop(1, "rgba(196,18,46,0.9)");
      ctx.strokeStyle = g;
      ctx.beginPath(); ctx.moveTo(cx, cy); ctx.lineTo(cx + Math.cos(ang) * R, cy + Math.sin(ang) * R); ctx.stroke();
      ang += 0.04;
      requestAnimationFrame(draw);
    };
    draw();
  });

  /* —— 505 CRT snow (poor OS, not the pretty machine) —— */
  const snow = document.getElementById("FxSnow");
  if (snow && (in505 || document.body.classList.contains("is-505"))) {
    const ctx = snow.getContext("2d");
    const fit = () => { snow.width = 220; snow.height = 124; };
    fit();
    const draw = () => {
      const id = ctx.createImageData(snow.width, snow.height);
      const d = id.data;
      for (let i = 0; i < d.length; i += 4) {
        const v = Math.random() * 48;
        d[i] = d[i + 1] = d[i + 2] = v;
        d[i + 3] = 70;
      }
      ctx.putImageData(id, 0, 0);
      requestAnimationFrame(draw);
    };
    if (!reduced) draw();
  }

  /* —— house fault: our own broken OS, not 505 snow and not a cloned HUD —— */
  const fault = document.getElementById("FxFault");
  if (fault && !in505 && !reduced) {
    const ctx = fault.getContext("2d");
    const specks = Array.from({ length: 36 }, () => ({
      x: Math.random(),
      y: Math.random(),
      w: 1 + Math.random() * 3,
      h: 1 + Math.random() * 2,
      red: Math.random() > 0.68,
      vy: 0.00015 + Math.random() * 0.0004
    }));
    let tears = [];
    let nextTear = 0;
    const fit = () => {
      const dpr = Math.min(devicePixelRatio || 1, 1.25);
      fault.width = Math.min(innerWidth, 1100) * dpr;
      fault.height = Math.min(innerHeight, 700) * dpr;
    };
    fit();
    addEventListener("resize", fit);
    const draw = (now) => {
      const w = fault.width, h = fault.height;
      ctx.clearRect(0, 0, w, h);
      const broken = document.body.classList.contains("is-broken");
      const storm = document.body.classList.contains("is-storming");
      const specN = broken ? (storm ? 110 : 80) : 70;
      for (let i = 0; i < specN; i++) {
        const red = Math.random() > (broken ? 0.82 : 0.88);
        ctx.fillStyle = red ? "rgba(196,18,46,0.16)" : "rgba(244,241,236,0.1)";
        ctx.fillRect(Math.random() * w, Math.random() * h, 1, 1 + Math.random() * 2);
      }
      specks.forEach((p) => {
        ctx.fillStyle = p.red ? "#c4122e" : "#f4f1ec";
        ctx.fillRect(p.x * w, p.y * h, p.w, p.h);
        p.y += p.vy;
        if (p.y > 1) p.y = 0;
      });
      if (now > nextTear) {
        nextTear = now + (broken ? (storm ? 40 + Math.random() * 220 : 90 + Math.random() * 520) : 500 + Math.random() * 1400);
        if (broken && Math.random() > (storm ? 0.22 : 0.4)) {
          const n = 1 + (Math.random() > 0.55 ? 1 : 0) + (storm && Math.random() > 0.7 ? 1 : 0);
          for (let k = 0; k < n; k++) {
            tears.push({
              axis: Math.random() > 0.78 ? "v" : "h",
              y: Math.random() * 0.9,
              x: Math.random() * 0.9,
              h: 0.004 + Math.random() * (storm ? 0.06 : 0.035),
              w: 0.004 + Math.random() * 0.03,
              shift: (Math.random() - 0.5) * (storm ? 48 : 32),
              until: now + 40 + Math.random() * (storm ? 220 : 280)
            });
          }
          if (tears.length > 5) tears = tears.slice(-5);
        }
      }
      tears = tears.filter((tr) => now < tr.until);
      if (tears.length) document.body.classList.add("is-tearing");
      else document.body.classList.remove("is-tearing");
      tears.forEach((tr) => {
        if (tr.axis === "v") {
          const x = tr.x * w + tr.shift;
          const ww = Math.max(1, tr.w * w);
          ctx.fillStyle = "rgba(244,241,236,0.1)";
          ctx.fillRect(x, 0, ww, h);
          ctx.fillStyle = "rgba(196,18,46,0.55)";
          ctx.fillRect(x, 0, 1, h);
        } else {
          const y = tr.y * h;
          const hh = Math.max(2, tr.h * h);
          ctx.fillStyle = "rgba(244,241,236,0.1)";
          ctx.fillRect(tr.shift, y, w, hh);
          ctx.fillStyle = "rgba(196,18,46,0.55)";
          ctx.fillRect(0, y, w, 1);
          ctx.fillStyle = "rgba(244,241,236,0.35)";
          ctx.fillRect(tr.shift + 12, y + hh, w * 0.4, 1);
        }
      });
      requestAnimationFrame(draw);
    };
    draw(0);
  }

  /* —— winamp drag (desktop) —— */
  const amp = document.querySelector("[data-winamp]");
  const ampBar = document.querySelector("[data-winamp-drag]");
  if (amp && ampBar && !coarse) {
    let held = false, ox = 0, oy = 0;
    ampBar.addEventListener("pointerdown", (e) => {
      held = true;
      const r = amp.getBoundingClientRect();
      ox = e.clientX - r.left;
      oy = e.clientY - r.top;
      amp.style.position = "fixed";
      amp.setPointerCapture(e.pointerId);
    });
    amp.addEventListener("pointermove", (e) => {
      if (!held) return;
      amp.style.left = (e.clientX - ox) + "px";
      amp.style.top = (e.clientY - oy) + "px";
      amp.style.right = "auto";
      amp.style.bottom = "auto";
    });
    amp.addEventListener("pointerup", () => { held = false; });
  }
})();
